/**
 * Formats the data for a reference so that it is viewable in an equation.
 *
 */
import i18n from 'scoreboard/components/i18n'

import constants from 'scoreboard/components/constants'
import _ from 'lodash'

var metricEquationFormatter = {

	format: function(data) {
		var method = data.type
		return this[method](data)
	},

	/**
	 * Formats a metric or threshold reference using data like this:
	 *
	 * <pre>
	 * {
	 * 	type : 'metric',
	 * 	id : 25,
	 * 	series : 'scorecards.node.metric.threshold.base',
	 * 	periodNumber : 3,
	 * 	periodDirection : 'common.earlier'
	 * }
	 * </pre>
	 */
	metric: function(data) {
		var relative = ''
		if (data.periodDirection && 'common.current' != data.periodDirection) {
			if ('common.earlier' == data.periodDirection) {
				relative += '-'
			}
			relative += data.periodNumber + 'p'
		}
		if (!data.series ||
				constants.ACTUAL_VALUE == data.series ||
				constants.SCORE == data.series) {
			var comma = data.id && !_.isEmpty(relative) ? ',' : ''
			var prefix = (constants.SCORE == data.series || data.type == 'score') ? 'S' : 'M'
			return prefix + '(' + (data.id || '') + comma + relative + ')'
		}
		else {
			var threshold = i18n.get(data.series)
			var result = 'T('
			if (data.id) {
				result += data.id + ','
			}
			var comma = _.isEmpty(relative) ? '' : ','
			return result + threshold + comma + relative + ')'
		}
	},

	/**
	 * Formats a score reference using data like this:
	 *
	 * <pre>
	 * {
	 * 	type: 'score',
	 * 	series: 'scorecards.node.score',
	 * 	id: 3,
	 * 	periodNumber: 1,
	 * 	periodDirection: 'common.earlier'
	 * }
	 * </pre>
	 */
	score: function(data) {
		return this.metric(data)
	},

	/**
	 * Formats an initiative reference using data like this:
	 *
	 * <pre>
	 * {
	 * 	type : 'initiative',
	 * 	id : 26,
	 * 	calculation : 'initiatives.calculation.percentTimeElapsed'
	 * }
	 * </pre>
	 */
	initiative: function(data) {
		var acronym = i18n.get(data.calculation + '.acronym')
		return 'I(' + acronym + ',' + data.id + ')'
	},

	/**
	 * Formats a to-date reference using data like this:
	 *
	 * <pre>
	 * {
	 * 	type : 'td',
	 * 	id : 27,
	 * 	calendar : 'Monthly',
	 * 	series : 'scorecards.node.metric.threshold.base',
	 * 	aggregation : 'scorecards.node.metric.aggregationType.sum'
	 * }
	 * </pre>
	 */
	td: function(data) {
		var result = 'TD(' + data.calendar + ',' + data.id
		if (data.series) {
			result += ',' + i18n.get(data.series)
		}
		if (data.aggregation) {
			result += ',' + i18n.get(data.aggregation)
		}
		return result + ')'
	}

}

export default metricEquationFormatter

metricEquationFormatter.__filename__ = 'scorecards/metric-equation-formatter.js'
